/**
 * Created by shubham on 15/02/19.
 */

import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpService } from '../shared/services/http.service'
import { MdDialog } from '@angular/material';
import { DialogComponent } from '../dialog/dialog.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonService } from '../shared/services/common.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import {TranslateService} from 'ng2-translate';

@Component({
    template: require('./unlockAccount.component.html')
})

export class UnlockAccountComponent {
    data: any = [];
    dialogRef;
    id: any;
    languageId: any;
    UnlockAccountForm: FormGroup;
    UnlockAccountFormDetails: any;

    constructor(private router: Router, private route: ActivatedRoute, private httpService: HttpService, private sessionHandler: SessionHandler,
                public dialog: MdDialog, private translate: TranslateService, private formBuilder: FormBuilder, private commonService: CommonService) {
    }

    buildForm() {
        this.UnlockAccountForm = this.formBuilder.group({
            userId_WPASS: this.formBuilder.control(null, [Validators.required]),
        });
        this.UnlockAccountForm.valueChanges.subscribe(data => {
            this.UnlockAccountFormDetails = this.UnlockAccountForm.getRawValue();
        });
    }

    public unlockAccount(){
        this.httpService.postRequest(this.UnlockAccountFormDetails,'userOperationsApi/v1/unlockWpassUser').subscribe(
            res => { this.saveResponse(res); },
            err => {
                this.httpService.onEnd();
            }
        );
    }

    public saveResponse(res){
        if(res){
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'account_unlock_succesfully';
            this.dialogRef.afterClosed().subscribe(result => {
                this.router.navigateByUrl('/login');
            });
        }
        this.httpService.onEnd();
    }

    ngOnInit(): void {
        this.buildForm();
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/unlock-account/UnlockAccountComponent.ts